import Immutable from 'immutable';

import PredicateRule from 'sharedreact/data/PredicateRule';

const Content: {
  rules: Immutable.List<PredicateRule>
} = {
  rules: Immutable.List()
};

class Predicate extends Immutable.Record(Content) {
  addRule (attribute: string | null, value: string, operator: string): Predicate {
    return this.set('rules', this.rules.push(PredicateRule.createRule(attribute || null, value, operator)));
  }

  addAND (): Predicate {
    return this.set('rules', this.rules.push(PredicateRule.createAND()));
  }

  addOR (): Predicate {
    return this.set('rules', this.rules.push(PredicateRule.createOR()));
  }

  addNOT (): Predicate {
    return this.set('rules', this.rules.push(PredicateRule.createNOT()));
  }

  static createFromRules (rules: [PredicateRule]): Predicate {
    return new Predicate({rules: Immutable.List(rules)});
  }

  static createFromRuleData (attribute: string | null, value: string, operator: string): Predicate {
    return Predicate.createEmpty().addRule(attribute, value, operator);
  }

  static createEmpty (): Predicate {
    return new Predicate({rules: Immutable.List()});
  }
}


export default Predicate;
